import { useMemo } from 'react';
import { getContracts, type MethaContracts } from '../lib/contracts';
import { useReadProvider } from './useReadProvider';

/**
 * Read-only contract instances bound to the best available provider.
 * For writes, use useSignerContracts() from useWallet (only available when connected).
 */
export function useReadContracts(): MethaContracts {
  const provider = useReadProvider();
  return useMemo(() => getContracts(provider), [provider]);
}
